"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _managedCalendar = _interopRequireDefault(require("./managedCalendar"));
var _applying = _interopRequireDefault(require("./applying"));
var _applicationStatus = _interopRequireDefault(require("./applicationStatus"));
var _applicationEditability = _interopRequireDefault(require("./applicationEditability"));
var _myApplications = _interopRequireDefault(require("./myApplications"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var _ref = /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_managedCalendar.default, null), /*#__PURE__*/_react.default.createElement(_applicationStatus.default, null), /*#__PURE__*/_react.default.createElement(_applying.default, null), /*#__PURE__*/_react.default.createElement(_myApplications.default, null), /*#__PURE__*/_react.default.createElement(_applicationEditability.default, null));
const CalendarHelp = () => {
  return _ref;
};
var _default = exports.default = CalendarHelp;